import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaFileUpload, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import axios from 'axios';
import './AttachReceiptPage.css';

const AttachReceiptPage = () => {
  const [formData, setFormData] = useState({
    receipt: null,
    invoiceNumber: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleFileChange = (e) => {
    setFormData({ ...formData, receipt: e.target.files[0] });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setErrorMessage('');

    if (!formData.receipt || !formData.invoiceNumber) {
      setLoading(false);
      setErrorMessage('Please provide a receipt file and an invoice number.');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('receipt', formData.receipt);
    formDataToSend.append('invoiceNumber', formData.invoiceNumber);

    try {
      const response = await axios.post('https://agpipefitting.org.et/api/submit-receipt', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        setMessage('Receipt sent successfully!');
      } else {
        setErrorMessage('Failed to send the receipt. Please try again.');
      }
    } catch (error) {
      setErrorMessage('Failed to send the receipt. Please try again.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="attach-receipt-page bg-light">
      <div className="container-fluid d-flex justify-content-center align-items-center py-5">
        <div className="card shadow-lg p-5 rounded">
          <h2 className="text-center mb-4 text-primary">Attach Bank Receipt</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="invoiceNumber" className="form-label">
                <strong>Invoice Number</strong>
              </label>
              <input
                type="text"
                id="invoiceNumber"
                name="invoiceNumber"
                className="form-control shadow-sm"
                value={formData.invoiceNumber}
                onChange={handleInputChange}
                required
                placeholder="Enter invoice number"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="receipt" className="form-label">
                <FaFileUpload className="me-2 text-primary" />
                <strong>Attach Bank Receipt (PDF or Image)</strong>
              </label>
              <input
                type="file"
                id="receipt"
                name="receipt"
                className="form-control shadow-sm"
                accept=".pdf, .jpg, .jpeg, .png"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="text-center mt-4">
              <button
                type="submit"
                className="btn btn-primary w-100 shadow-sm submit-btn"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Receipt'}
              </button>
            </div>
          </form>
          {message && (
            <div className="mt-3 alert alert-success d-flex align-items-center">
              <FaCheckCircle className="me-2" />
              <span>{message}</span>
            </div>
          )}
          {errorMessage && (
            <div className="mt-3 alert alert-danger d-flex align-items-center">
              <FaExclamationCircle className="me-2" />
              <span>{errorMessage}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttachReceiptPage;
